import { useState } from "react";
import { toast } from "sonner";
import { Pencil } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function DisplayNameEditor({ onSaved }) {
  const { user, setUser } = useAuth();
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(user?.display_name || "");
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put("/auth/display-name", { display_name: name });
      setUser(data); setEditing(false); toast.success("Display name updated"); onSaved?.(data);
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  if (!editing) return <button type="button" onClick={() => { setName(user.display_name); setEditing(true); }} className="inline-flex items-center gap-1 text-xs text-slate-400 hover:text-white" data-testid="edit-display-name-button"><Pencil size={12} /> Change name</button>;
  return (
    <form onSubmit={save} className="mt-2 flex gap-2" data-testid="display-name-form">
      <input className="field py-2 text-sm" value={name} onChange={(e) => setName(e.target.value)} minLength={3} maxLength={24} required autoFocus data-testid="display-name-input" />
      <button className="btn-primary px-3 py-2 text-sm" disabled={busy} data-testid="display-name-save-button">{busy ? "…" : "Save"}</button>
      <button type="button" className="btn-secondary px-3 py-2 text-sm" onClick={() => setEditing(false)} data-testid="display-name-cancel-button">Cancel</button>
    </form>
  );
}
